














































































import { KasasaUpgrade, KasasaUpgradeResource, KasasaUpgradeTableItem } from '@/api/kasasaupgrade';
import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Watch, Prop, Inject,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import KasasaUpgradeCreateDialog from '@/components/KasasaUpgradeCreateDialog.vue';
import { Dialog } from '@kasasa/fbase-components/lib';
import { ProductMapping } from '@/api/productmapping';
import { DateTool, KasasaAccountUpgradeUtil } from '@/util';
import { DisplayAccountProductCode } from '@/util/kasasaaccountupgrade/DisplayAccountProductCode';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KasasaUpgradeCreateDialog,
  },
})
export default class KasasaUpgradeView extends Vue {
  @Prop() value!: KasasaUpgrade[];

  @Prop() productMap!: Map<number, ProductMapping>;

  @Prop() nonKasasaProductCodes!: DisplayAccountProductCode[];

  @Prop() kasasaProducts!: ProductMapping[];

  @Prop({ default: false }) loading!: boolean;

  kasasaUpgradeTableItems: KasasaUpgradeTableItem[] = [];

  @Inject('KasasaUpgradeResource')
  kasasaUpgradeResource!: KasasaUpgradeResource;

  fiId!: string;

  kasasaUpgradeTableHeads: DataTableHeader[] = [
    {
      text: '', value: 'edit', align: 'start', sortable: false, width: '5%',
    },
    {
      text: 'Start Date', value: 'startDate', align: 'start', sortable: true, width: '10%',
    },
    {
      text: 'End Date', value: 'endDate', align: 'start', sortable: true, width: '10%',
    },
    {
      text: 'From Non Kasasa Products', value: '', align: 'start', sortable: false, width: '45%',
    },
    {
      text: 'To Kasasa Products', value: '', align: 'start', sortable: false, width: '25%',
    },
    {
      text: '', value: '', align: 'start', sortable: false, width: '5%',
    },
  ];

  mounted() {
    if (this.value) {
      KasasaAccountUpgradeUtil.buildKasasaUpgradeTableItems(this.value, this.productMap, this.kasasaUpgradeTableItems);
    }
  }

  @Watch('value')
  onValueUpdate() {
    if (this.value) {
      KasasaAccountUpgradeUtil.buildKasasaUpgradeTableItems(this.value, this.productMap, this.kasasaUpgradeTableItems);
    }
  }

  isUpgradePastEffectiveDate = (upgrade: KasasaUpgrade): boolean => {
    if (!upgrade || !upgrade.startDate) {
      return true;
    }

    const today = DateTool.getAustinDate();
    const upgradeStartDate = DateTool.parseDate(upgrade!.startDate);

    return today >= upgradeStartDate;
  }

  toDisplayDate = (date: string):string => DateTool.toFriendlyFormatFromIsoFormatString(date)

  onUpgradeSaved(savedUpgrade:KasasaUpgrade) {
    this.$emit('success', savedUpgrade);
  }

  onUpgradeSaveError(error:any) {
    this.$emit('onError', error);
  }

  onDeleteItem(upgrade: KasasaUpgrade) {
    const dialog = new Dialog('Confirm Deletion', 'Are you sure you want to delete the Kasasa Upgrade record?');
    dialog.setAcceptLabel('OK').setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          this.kasasaUpgradeResource
            .delete(this.fiId, upgrade)
            .then((savedUpgrade: KasasaUpgrade) => {
              this.$emit('deleted', upgrade);
            })
            .catch((error:any) => {
              this.$emit('onError', error);
            });
        }
      });
  }
}

